import React from 'react'
import ClientSuspense from '@components/ClientSuspense'
import Loading from '@components/SuspenseLoading/Loading'
import {useWebsiteMenuInformation} from '@data/queries/website/websiteMenuInformation.main'
import useIsStore from '@hooks/useIsStore'
import useProductsLayout from '@page-components/Order/useProductsLayout'
import dynamic from 'next/dynamic'

const LongOrCompactCPG = dynamic(() => import('@page-components/Order/LongOrCompactCPG'))
const ProductsLayout = dynamic(() => import('@page-components/Order/Products'))
const CategoriesLayout = dynamic(() => import('@page-components/Order/CategoriesLayout'))

export default function Products() {
  const isStore = useIsStore()
  const {website} = useWebsiteMenuInformation()
  const productsLayout = useProductsLayout(website)

  if (productsLayout == 'categories') return <CategoriesLayout />

  if (isStore) {
    return (
      <ClientSuspense fallback={<Loading />}>
        <LongOrCompactCPG />
      </ClientSuspense>
    )
  }

  return <ProductsLayout />
}
